"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.summary = exports.addChildren = void 0;

var http_1 = require("./http");

var uri = '/v5/data/graph';

function addChildren(credentials, parent, children, relationType, note, move) {
  var e_1, _a;

  var endpoint = uri + "/" + parent.string() + "/children";
  var childrenStr = [];

  try {
    for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
      var child = children_1_1.value;
      childrenStr.push(child.string());
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return http_1.authorizedHTTP(credentials).post(endpoint, {
    children: childrenStr,
    relationType: relationType,
    note: note,
    move: move
  }).then(function (resp) {
    return resp.data;
  });
}

exports.addChildren = addChildren;

function summary(credentials, node) {
  var endpoint = uri;

  if (node && node.valid() && node.string() !== "00000000-0000-0000-0000-000000000000") {
    endpoint = endpoint + "/" + node.string() + "/summary";
    return http_1.authorizedHTTP(credentials).get(endpoint).then(function (resp) {
      return resp.data;
    });
  }

  return Promise.resolve();
}

exports.summary = summary;

function default_1(credentials, fields, node, time, limitExpression) {
  var endpoint = uri;
  var params = {
    fields: fields.join(",")
  };

  if (time != null) {
    params['time'] = Math.floor(time.getTime() / 1000);
  }

  if (limitExpression != null && limitExpression.length > 1) {
    params['q'] = limitExpression;
  }

  if (node && node.valid() && node.string() !== "00000000-0000-0000-0000-000000000000") {
    endpoint = endpoint + "/" + node.string();
  }

  return http_1.authorizedHTTP(credentials).get(endpoint, {
    params: params,
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;